 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + width() + ' ' + (height() + 150)"
        preserveAspectRatio="xMidYMin meet">
        
        <g shadow-type-1 [height]="height()"/>
        <g wall-type-8 [height]="height()"></g>
        
        <g roof-type-8/>
        <g outline />
        <g window-type-9 [height]="height()" [windowMargin]="50"/>
        <g foundation-type-1/>

</svg>